"use strict";

import http from "@/http";
import constants from "../utils/constants";

const BASE_NAME = "/contractor-type";

const list = async () => {
  const response = await http.get(`${BASE_NAME}`);
  return response.data;
};

const getById = async id => {
  const response = await http.get(`${BASE_NAME}/${id}`);
  return response.data;
};

const create = async data => {
  const response = await http.post(`${BASE_NAME}`, data);
  return response.data;
};

const edit = async contractorType => {
  const response = await http.put(
    `${BASE_NAME}/${contractorType._id}`,
    contractorType
  );
  return response.data;
};

const remove = async id => {
  const response = await http.delete(`${BASE_NAME}/${id}`);
  return response.data;
};

const getObligations = async () => {
  const response = await http.get(`/obligations?type=` + constants.OBLIGATIONS.TYPES.OBLIGATION);
  return response.data;
};

const getVehicles = async () => {
  const response = await http.get(`${BASE_NAME}/vehicles`);
  return response.data;
};

export default {
  list,
  getById,
  create,
  edit,
  remove,
  getObligations,
  getVehicles
};
